import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ActivatedRoute } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { MultiSelectComponent } from 'ng-multiselect-dropdown';
import { Location } from '@angular/common';
import {
  IDropdownSettings,
  ListItem,
} from 'ng-multiselect-dropdown/multiselect.model';
import {
  combineLatest,
  first,
  fromEvent,
  switchMap,
  takeUntil,
  tap,
  throwError,
} from 'rxjs';
import { MydocumentsItemAdapterService } from '../core/http/adapters/mydocuments-item/mydocuments-item.service';
import { DOCUMENT } from '@angular/common';
import { ParametersService } from '../shared/services/parameters/parameters.service';
import { MatStepper } from '@angular/material/stepper';
import {
  getValue,
  isDefined,
  isDefinedAndFilledArray,
  isDefinedAndFilledString,
  isUndefinedOrNull,
  SOVerify,
} from '../shared/utility/verify.lib';
import { Store } from '@ngrx/store';
import {
  getAvailableCadTypes,
  getAvailableDocumentTypes,
  setCurrentStep,
  setInitialSession,
} from '../redux/mydoc.action';
import {
  availableCadTypes,
  availableDocumentTypes,
  documentSession,
  needToSaveSettings,
  savedConfiguration,
  selectedCadTypes,
  selectedDocumentTypes,
  selectedLanguages,
  selectedProducts,
  showErrorMessage,
  storedExportSettings,
  storedSession,
} from '../redux/mydoc.selector';
import { IExportConfiguration } from '../models/export/export-configuration.model';
import { IExportStructure } from '../models/export/export-structure.model';
import { IAvailableDocumentLanguages } from '../models/language/available-document-languages.model';
import { ILanguageText } from '../models/language/language-text.model';
import { StoreUpdaterService } from '../shared/services/store-updater/store-updater.service';
import { IProductItem } from '../models/item/product-item.model';
import { SavingExportService } from '../shared/services/saving-export/saving-export.service';
import { ICadType } from '../models/document/cad-type.model';
import { IDocumentType } from '../models/document/document-type.model';
import { ICadSimpleType } from '../models/document/cad-simple-type.model';
import { IDocumentTypeText } from '../models/document/document-type-text.model';
import { IDocumentSession } from '../models/session/document-session.model';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { SubscriptionComponent } from '../shared/subscription/subscription.component';
import { DocumentTypeHelperService } from './export/services/document-type-helper/document-type-helper.service';
import { ProductItemHelperService } from './export/services/product-item-helper/product-item-helper.service';
import { CadfileTypeHelperService } from './export/services/cadfile-type-helper/cadfile-type-helper.service';
import { TrackingHelperService } from './export/services/tracking-helper/tracking-helper.service';
import { TrackingPreparationService } from './export/services/tracking-preparation/tracking-preparation.service';
import { IExportSettingsFe } from '../models/export/export-settings-fe.model';

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [],
})
export class WizardComponent
  extends SubscriptionComponent
  implements OnInit, AfterViewInit
{
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChildren('selectedFormat')
  selectedFormat!: QueryList<MultiSelectComponent>;

  public isEndOfWizard: boolean = false;
  public uniqueSessionIdByDocumentItems!: IProductItem[];
  public selectableDocumentsCount!: number;
  public isLinear = true;
  public showMoreDocuments = false;
  public countCheckboxChecked = 0;
  public documentItems!: IProductItem[];
  public activeLanguage!: string;
  public orderedDocumentTypes: IDocumentType[];
  public isAuthError: boolean = false;
  public callFailedIsShown: boolean = false;
  public uniques: string[];
  public cadFileTypeWithUniqueFormats: string[] = [];
  public selectedCadFileTypeViews: ICadSimpleType[] = [];
  public dropdownSettings: IDropdownSettings = {};
  public dropdownSettingsView: IDropdownSettings = {};
  public queryParams!: any;
  public areDocumentTypesValid: boolean = false;
  public areCadDrawingsValid: boolean = true;
  public areAllProductsSelected: boolean = false;

  public isProductItemHasDocuments: Record<string, boolean> = {};
  public productItemTextInActiveLanguage: Record<string, string> = {};
  public documentTextInActiveLanguage: Record<string, string> = {};
  public isDocumentTypeAvailableAfterProduction: Record<string, boolean> = {};
  public isProductItemChecked: Record<string, boolean> = {};
  public isDocumentTypeChecked: Record<string, boolean> = {};
  public areProductsSelected: boolean = false;
  public session$ = this.store.select(storedSession);
  public areExportSettingsComplete: boolean = false;
  public availableCadTypes$ = this.store.select(availableCadTypes);
  public availableDocumentTypes$ = this.store.select(availableDocumentTypes);

  private selectedProducts$ = this.store.select(selectedProducts);
  private selectedLanguages$ = this.store.select(selectedLanguages);
  private selectedDocumentTypes$ = this.store.select(selectedDocumentTypes);
  private selectedCadTypes$ = this.store.select(selectedCadTypes);
  private savedConfiguration$ = this.store.select(savedConfiguration);
  private exportSettings$ = this.store.select(storedExportSettings);
  private documentSession$ = this.store.select(documentSession);
  private showErrorMessage$ = this.store.select(showErrorMessage);
  private needToSaveSettings$ = this.store.select(needToSaveSettings);

  private sessionType!: string;
  private cadFileTypes!: ICadType[];
  private availableDocumentTypes!: IDocumentType[];

  public constructor(
    private translocoService: TranslocoService,
    private myDocumentsItem: MydocumentsItemAdapterService,
    private activatedRoute: ActivatedRoute,
    private paramsService: ParametersService,
    private changeDetectorRef: ChangeDetectorRef,
    private location: Location,
    private store: Store,
    private storeUpdaterService: StoreUpdaterService,
    private savingExportService: SavingExportService,
    private documentTypeHelperService: DocumentTypeHelperService,
    private cadfileTypeHelperService: CadfileTypeHelperService,
    private productItemHelperService: ProductItemHelperService,
    private trackingHelperService: TrackingHelperService,
    private trackingPreparationService: TrackingPreparationService,
    @Inject(DOCUMENT) public document: Document
  ) {
    super();
  }

  public ngOnInit(): void {
    this.translocoService
      .selectTranslate([
        'eh-mydocuments-cad-nodata',
        'eh-mydocuments-cad-search',
        'eh-mydocuments-cad-selectall',
      ])
      .subscribe((translation) => {
        this.prepareDropdowns(translation);
      });
    this.addSelectedCadFileTypes();
    this.myDocumentsItem.activeLanguageChanged.subscribe((defaultLanguage) => {
      this.activeLanguage = defaultLanguage.toUpperCase();
    });

    this.showErrorMessage$
      .pipe(takeUntil(this.completeAll$))
      .subscribe((showError: boolean) => (this.callFailedIsShown = showError));
  }

  public ngAfterViewInit(): void {
    this.initView();
    this.queryParams = {
      'nebp.cartid': this.activatedRoute.snapshot.queryParams['nebp.cartid'],
      'nebp.language':
        this.activatedRoute.snapshot.queryParams['nebp.language'],
      sessionId: this.activatedRoute.snapshot.queryParams['sessionId'],
      orderNumber: this.activatedRoute.snapshot.queryParams['orderNumber'],
    };

    this.validateExportStep();

    this.store.dispatch(
      setInitialSession({
        id: this.queryParams.sessionId,
        orderNumber: this.queryParams.orderNumber,
        language: this.getSessionLanguage(),
      })
    );

    fromEvent(window, 'scroll').subscribe((event) => {
      this.onScroll(event.target);
    });

    this.documentSession$
      .pipe(takeUntil(this.completeAll$))
      .subscribe((documentSession: IDocumentSession) => {
        if (isDefined(() => documentSession.type)) {
          this.sessionType = documentSession.type;
        }
        this.updateProductSpecificInformation(documentSession?.items);
      });

    this.selectedProducts$
      .pipe(takeUntil(this.completeAll$))
      .subscribe((products: IProductItem[]) => {
        this.areProductsSelected = isDefinedAndFilledArray(() => products);
        this.countCheckboxChecked = Object.values(
          this.isProductItemChecked
        ).filter((isChecked: boolean) => isChecked)?.length;
      });
  }

  public onChangeAllProductsSelection(event: MatCheckboxChange): void {
    this.areAllProductsSelected = !this.areAllProductsSelected;
    if (
      isDefinedAndFilledArray(() => Object.values(this.isProductItemChecked))
    ) {
      Object.keys(this.isProductItemChecked).forEach((key: string) => {
        this.isProductItemChecked[key] =
          this.isProductItemHasDocuments[key] && event.checked;
      });
    }

    this.trackingHelperService.trackSelectAllProducts(
      getValue(() => event.checked, false),
      this.sessionType
    );

    this.storeUpdaterService.updateSelectedItemsInStore(
      this.isProductItemChecked,
      this.documentItems
    );
  }

  public onChangeProductSelection(
    event: MatCheckboxChange,
    product: IProductItem
  ): void {
    const posNumber: string = getValue(() => product.posNumber);
    if (
      isDefined(() => posNumber) &&
      this.isProductItemHasDocuments[posNumber]
    ) {
      this.isProductItemChecked[posNumber] = event.checked;
      this.countCheckboxChecked =
        this.productItemHelperService.countOfSelectedProduct(
          this.isProductItemChecked
        );
    } else {
      this.isProductItemChecked[posNumber] = false;
    }
    this.checkIfAllProductsAreChecked();
    this.storeUpdaterService.updateSelectedItemsInStore(
      this.isProductItemChecked,
      this.documentItems
    );
  }

  public trackNextStepProduct(): void {
    this.trackingHelperService.trackNextStepOnProductPage(this.sessionType);
  }

  public trackNextStepDocument(): void {
    this.trackingHelperService.trackNextStepOnDocumentTypePage(
      this.sessionType
    );
  }

  public trackBackStepDocument(): void {
    this.trackingHelperService.trackBackStepOnDocumentTypePage(
      this.sessionType
    );
  }

  public navigateBackInBrowserHistory(): void {
    this.location.back();
  }

  public trackBackStepLanguage(): void {
    this.trackingHelperService.trackBackStepOnExportSettingsPage(
      this.sessionType
    );
  }

  public showMoreAndLessDocumentTypes(): void {
    this.isEndOfWizard = false;
    this.trackingHelperService.trackShowMoreAndLessDocumentTypes(
      this.sessionType,
      this.showMoreDocuments
    );
    this.showMoreDocuments = !this.showMoreDocuments;
  }

  public getSaveUserEntries(): void {
    this.savingExportService.saveUserSettings();
    this.savingExportService.saveUserEntries();

    const documentTypeTexts: IDocumentTypeText[] =
      this.getLatestValueFromSubscription(this.selectedDocumentTypes$);
    const docTypesTrackingSemi: string =
      this.trackingPreparationService.getDocumentTypeText(
        documentTypeTexts,
        ';'
      );
    const docTypesTrackingPipe: string =
      this.trackingPreparationService.getDocumentTypeText(
        documentTypeTexts,
        '|'
      );

    const exportSettings: IExportSettingsFe =
      this.getLatestValueFromSubscription(this.exportSettings$);
    const exportSettingsComb: string =
      this.trackingPreparationService.getFolderFileText(
        exportSettings?.savedConfiguration,
        '|',
        true
      );
    const exportSettingsSeparate: string =
      this.trackingPreparationService.getFolderFileText(
        exportSettings?.savedConfiguration,
        ';',
        false
      );

    const filledExportLevel: string =
      this.trackingPreparationService.getFilledExportLevel(
        exportSettings?.savedConfiguration
      );

    const languageIds: string[] = this.getLatestValueFromSubscription(
      this.selectedLanguages$
    ).map((languageText: ILanguageText) => languageText?.languageId);

    const productPosNumbers: string[] = this.getLatestValueFromSubscription(
      this.selectedProducts$
    ).map((productItem: IProductItem) => productItem.posNumber);

    const saveSettingsAsDefault: boolean = this.getLatestValueFromSubscription(
      this.needToSaveSettings$
    );

    this.trackingHelperService.trackSaveUserEntries(
      this.sessionType,
      docTypesTrackingSemi,
      docTypesTrackingPipe,
      exportSettingsComb,
      exportSettingsSeparate,
      filledExportLevel,
      languageIds,
      productPosNumbers,
      saveSettingsAsDefault
    );
  }

  public changeStep(index: StepperSelectionEvent): void {
    window.scrollTo(0, 0);
    this.trackingHelperService.trackChangeStep(
      this.sessionType,
      getValue(() => index.selectedIndex, 0)
    );
    this.store.dispatch(setCurrentStep({ currentStep: index?.selectedIndex }));
  }

  public setSelectedCadFileTypeView(event: ListItem, viewIndex: number): void {
    this.selectedCadFileTypeViews[viewIndex].cadFormat =
      event as unknown as string;
    this.selectedCadFileTypeViews[viewIndex].cadFileTypes = [];

    this.selectedFormat.forEach((item, itmeIndex) => {
      if (item && itmeIndex === viewIndex) {
        item.selectedItems = [];
      }
    });

    this.updateCadDrawingsValidation();
    this.cadFileTypeWithUniqueFormats =
      this.cadfileTypeHelperService.getCadFileTypeWithUniqueFormats(
        viewIndex,
        this.cadFileTypes,
        this.selectedCadFileTypeViews
      );
  }

  public setSelectedCadFileTypeFormat(event: ListItem, index: number): void {
    const selectedCadfileTypeFormat = event as unknown as string;

    if (
      !this.selectedCadFileTypeViews[index].cadFileTypes.includes(
        selectedCadfileTypeFormat
      )
    ) {
      this.selectedCadFileTypeViews[index].cadFileTypes.push(
        selectedCadfileTypeFormat
      );
    }

    this.updateCadDrawingsValidation();
  }

  public onItemDeSelect(event: ListItem, index: number): void {
    const selectedCadfileTypeFormat = event as unknown as string;

    if (
      this.selectedCadFileTypeViews[index].cadFileTypes.includes(
        selectedCadfileTypeFormat
      )
    ) {
      this.selectedCadFileTypeViews[index].cadFileTypes =
        this.selectedCadFileTypeViews[index].cadFileTypes.filter(
          (type) => type !== selectedCadfileTypeFormat
        );
    }

    this.updateCadDrawingsValidation();
  }

  public onSelectAll(event: ListItem[], index: number): void {
    this.selectedCadFileTypeViews[index].cadFileTypes =
      event as unknown as string[];

    this.updateCadDrawingsValidation();
  }

  public onDeSelectAll(event: ListItem[], index: number): void {
    this.selectedCadFileTypeViews[index].cadFileTypes = [];

    this.updateCadDrawingsValidation();
  }

  public addSelectedCadFileTypes(): void {
    this.selectedCadFileTypeViews.push({
      cadFormat: '',
      cadFileTypes: [],
    });

    this.updateCadDrawingsValidation();
  }

  public deleteSelectedCadFileTypes(index: number): void {
    this.selectedCadFileTypeViews.splice(index, 1);

    this.updateCadDrawingsValidation();
  }

  public onCheckboxChange(
    event: MatCheckboxChange,
    i: number,
    documentValue: IDocumentType
  ): void {
    this.isDocumentTypeChecked[documentValue?.docTypeId] = event.checked;
    this.areDocumentTypesValid = Object.values(this.isDocumentTypeChecked).some(
      (isChecked: boolean) => isChecked
    );

    this.storeUpdaterService.updateDocumentTypesInStore(
      this.availableDocumentTypes,
      this.isDocumentTypeChecked
    );
    this.updateCadDrawingsValidation();
  }

  private prepareDropdowns(translation: string[]): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      noDataAvailablePlaceholderText: translation[0],
      searchPlaceholderText: translation[1],
      selectAllText: translation[2],
      maxHeight: 100,
    };

    this.dropdownSettingsView = {
      singleSelection: true,
      idField: 'item_id',
      textField: 'item_text',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      noDataAvailablePlaceholderText: translation[0],
      searchPlaceholderText: translation[1],
      selectAllText: translation[2],
      maxHeight: 100,
    };
  }

  private getSessionLanguage(): string {
    let returnValue: string = 'en';
    const contextLocale: string = SOVerify.getValueFromStructure(
      document,
      'nebpContext',
      'locale'
    );
    if (
      isDefinedAndFilledString(() =>
        this.trackingHelperService.getSiteLanguage()
      )
    ) {
      returnValue = this.trackingHelperService.getSiteLanguage().toLowerCase();
    } else if (isDefined(() => contextLocale)) {
      returnValue = contextLocale;
    }

    return returnValue;
  }

  private initView(): void {
    this.activatedRoute.queryParams
      .pipe(
        takeUntil(this.completeAll$),
        switchMap(() => {
          const paramsSessionId = this.paramsService.getCurrentSessionId();
          const paramsOrderNumber = this.paramsService.getCurrentOrderNumber();
          if (paramsSessionId) {
            return this.myDocumentsItem
              .myDocumentSessionGet(paramsSessionId, paramsOrderNumber)
              .pipe(
                tap(() => {
                  this.trackingHelperService.trackViewMyDocuments(
                    this.sessionType
                  );
                  this.myDocumentsItem
                    .getAvailableDocumentLanguages()
                    .pipe(first())
                    .subscribe(
                      (allLanguages: IAvailableDocumentLanguages[]) => {
                        this.storeUpdaterService.storeAvailableLanguages(
                          allLanguages
                        );
                      }
                    );

                  this.prepareDocumentTypes(
                    this.trackingHelperService.getSiteLanguage()
                  );
                })
              );
          } else {
            const err = new Error('auth');
            return throwError(() => err);
          }
        })
      )
      .pipe(first())
      .subscribe({
        next: (documentItem: IDocumentSession) => {
          if (documentItem?.items?.length) {
            this.documentItems = documentItem.items.sort(
              (a: IProductItem, b: IProductItem) =>
                parseInt(a.posNumber, 10) - parseInt(b.posNumber, 10)
            );
          }
          this.isProductItemHasDocuments =
            this.productItemHelperService.updateSelectableProductItems(
              this.documentItems
            );
          this.productItemTextInActiveLanguage =
            this.productItemHelperService.updateActiveLanguageTextForProduct(
              this.documentItems,
              this.activeLanguage
            );
          setTimeout(() => {
            this.setEndOfWizardProperty(
              window.scrollY,
              Math.max(
                document.body.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.clientHeight,
                document.documentElement.scrollHeight,
                document.documentElement.offsetHeight
              )
            );
          }, 0);
        },
        error: () => {
          this.getItemsCallFailed();
        },
      });
  }

  private getItemsCallFailed(): void {
    this.translocoService.setActiveLang(
      this.trackingHelperService.getSiteLanguage().toLowerCase()
    );
    // if getItemsByTokenAndCheckTokenAndOrderNoData call fails, retry once after short waiting time
    if (!this.isAuthError) {
      setTimeout(() => {
        this.initView();
      }, 300);
    }
    this.isAuthError = true;
  }

  private prepareDocumentTypes(language: string): void {
    this.store.dispatch(getAvailableDocumentTypes({ languageId: language }));
    this.store.dispatch(getAvailableCadTypes({ languageId: language }));

    this.availableDocumentTypes$
      .pipe(takeUntil(this.completeAll$))
      .subscribe((documentTypes: IDocumentType[]) => {
        const documentTypeOrder: IDocumentType[] = [];
        for (const documentType of documentTypes) {
          if (documentType) {
            documentTypeOrder.push(documentType);
          }
        }
        this.availableDocumentTypes = documentTypes;
        this.storeUpdaterService.updateDocumentTypesInStore(
          this.availableDocumentTypes,
          this.isDocumentTypeChecked
        );
        this.orderedDocumentTypes =
          this.documentTypeHelperService.getCheckboxesForDocuments(
            documentTypeOrder
          );
        this.isDocumentTypeAvailableAfterProduction =
          this.documentTypeHelperService.updateDocumentTypesAvailableAfterProduction(
            this.availableDocumentTypes,
            this.orderedDocumentTypes,
            this.documentTypeHelperService.checkIfProduced(
              this.getLatestValueFromSubscription(this.documentSession$)
            )
          );
        this.documentTextInActiveLanguage =
          this.documentTypeHelperService.updateActiveLanguageTextForDocumentType(
            this.availableDocumentTypes,
            this.activeLanguage
          );

        this.availableCadTypes$
          .pipe(takeUntil(this.completeAll$))
          .subscribe((cadDocumentTypes: ICadType[]) => {
            this.cadFileTypes = cadDocumentTypes;
            this.uniques =
              this.cadfileTypeHelperService.getCadFileTypeWithUniqueViews(
                this.cadFileTypes
              );
          });
      });
  }

  private updateProductSpecificInformation(items: IProductItem[]): void {
    if (isDefinedAndFilledArray(() => items)) {
      items.forEach((product: IProductItem) => {
        const posNumber: string = getValue(() => product.posNumber, null);
        this.isProductItemChecked[posNumber] =
          isDefined(() => posNumber) &&
          isDefined(() => this.isProductItemChecked[posNumber])
            ? this.isProductItemChecked[posNumber]
            : false;
        this.checkIfAllProductsAreChecked();
      });
    }
  }

  private checkIfAllProductsAreChecked(): void {
    const posNumbers: string[] = Object.keys(this.isProductItemChecked);
    const isFilledList: boolean = isDefinedAndFilledArray(() => posNumbers);
    let tempAreAllChecked: boolean = isFilledList;

    if (isFilledList) {
      posNumbers.forEach((key: string) => {
        if (
          !this.isProductItemChecked[key] &&
          (isUndefinedOrNull(() => this.isProductItemHasDocuments[key]) ||
            this.isProductItemHasDocuments[key])
        ) {
          tempAreAllChecked = false;
        }
      });
    }
    this.areAllProductsSelected = tempAreAllChecked;
  }

  private onScroll(target: any): void {
    this.setEndOfWizardProperty(
      target.scrollingElement.scrollTop,
      target.scrollingElement.scrollHeight
    );
  }

  private setEndOfWizardProperty(
    scrollTop: number,
    scrollHeight: number
  ): void {
    // visible height + pixel scrolled >= total height
    const footer: HTMLElement =
      this.document.getElementById('footer') ?? undefined;
    const euhFooterHeight: number = footer?.clientHeight ?? 0;
    if (scrollTop + window.innerHeight >= scrollHeight - euhFooterHeight) {
      this.isEndOfWizard = true;
    } else {
      this.isEndOfWizard = false;
    }
  }

  private updateCadDrawingsValidation(): void {
    this.storeUpdaterService.updateCadTypesInStore(
      this.selectedCadFileTypeViews,
      this.cadFileTypes
    );
    const selectedCadTypes: ICadType[] = this.getLatestValueFromSubscription(
      this.selectedCadTypes$
    );
    const areCadDrawingsSelected: boolean =
      getValue(() => selectedCadTypes.length, 0) > 0;

    this.areCadDrawingsValid =
      areCadDrawingsSelected || !this.isDocumentTypeChecked[11];
    this.changeDetectorRef.markForCheck();
  }

  private validateExportStep(): void {
    combineLatest([this.selectedLanguages$, this.savedConfiguration$])
      .pipe(takeUntil(this.completeAll$))
      .subscribe(
        ([languageList, savedConfig]: [
          ILanguageText[],
          IExportConfiguration
        ]) => {
          const isFolderConfigSet: boolean =
            isDefinedAndFilledArray(() => savedConfig.folderSetting) &&
            savedConfig.folderSetting.some((setting: IExportStructure) =>
              isDefined(() => setting)
            );
          const isFileConfigSet: boolean =
            isDefinedAndFilledArray(() => savedConfig.fileSetting) &&
            savedConfig.fileSetting.some((setting: IExportStructure) =>
              isDefined(() => setting)
            );
          this.areExportSettingsComplete =
            isDefinedAndFilledArray(() => languageList) &&
            isFolderConfigSet &&
            isFileConfigSet;
        }
      );
  }
}
